export default "__VITE_ASSET__CNzCzP9Y__"